import apiCore from '../../utils/api-core';

export function getFlowEnrollmentBoard(modulegroupId, campaignId) {
    const params = { modulegroup_id: modulegroupId };
    if (campaignId) params.campaign_id = campaignId;
    return apiCore.get('/api/v3/flow-enrollment/board', { params });
}

export function getContactEnrollments(contactId) {
    return apiCore.get('/api/v3/flow-enrollment/contact', { params: { contact_id: contactId } });
}

export function updateFlowEnrollment(id, data) {
    return apiCore.put(`/api/v3/flow-enrollment/${id}`, data);
}
